import { View, Text } from "react-native";
import { Play } from "lucide-react-native";
import { EMBER } from "../../../onboarding/theme";
import { StatusBadge } from "@louise/moon-ui";
import { semanticColors } from "@louise/theme/tokens";

type Props = {
  caption?: string;
  url?: string;
};

export default function VideoEmbed({ caption }: Props) {
  return (
    <View
      style={{
        borderRadius: 16,
        backgroundColor: semanticColors.surface.muted,
        borderWidth: 1,
        borderColor: semanticColors.border.subtle,
        padding: 24,
        alignItems: "center",
        justifyContent: "center",
        minHeight: 160,
        marginTop: 12,
        gap: 12,
      }}
    >
      <View
        style={{
          width: 48,
          height: 48,
          borderRadius: 24,
          backgroundColor: semanticColors.accent.tint,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Play size={20} color={EMBER.colors.warm} strokeWidth={2} />
      </View>
      {caption && (
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 13,
            color: EMBER.colors.textMid,
            textAlign: "center",
          }}
        >
          {caption}
        </Text>
      )}
      <StatusBadge type="coming-soon" />
    </View>
  );
}
